<template>
  <span class="menu-item-label">
    <template v-if="code">
      <span class="menu-item-label__code">{{ code }}</span
      ><span class="menu-item-label__dash"> – </span>
    </template>
    <span class="menu-item-label__title">{{ item.title }}</span>
    <span v-if="item.isNew && !hideNew" class="menu-item-label__new">new</span>
  </span>
</template>
<script>
export default {
  name: "menu-item-label",
  props: {
    item: {
      type: Object,
      required: true,
    },
    hideNew: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    code() {
      return (this.item.subTitle || "").trim();
    },
  },
};
</script>
<style lang="scss">
.menu-item-label {
  &__code {
    font-weight: 600;
    white-space: nowrap;
  }

  &__new {
    margin-left: 6px;
    padding: 1px 5px;
    border-radius: 2px;
    background-color: #333;
    color: #fff;
    font-size: 10px;
    line-height: 14px;
    text-transform: uppercase;
    vertical-align: middle;
  }
}
</style>
